import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseApp = firebase.initializeApp({
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID
});

export const authProviders = {
    Email: firebase.auth.EmailAuthProvider.PROVIDER_ID,
    Google: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    Facebook: firebase.auth.FacebookAuthProvider.PROVIDER_ID
}

export const auth = firebase.auth()
export const db = firebaseApp.firestore();
export const storage = firebaseApp.storage();


// WEBPACK FOOTER //
// ./src/firebase.js